import logger from '@shared/utils/error/logger';

export const tryParseJson = (str: string) => {
	let result: any;
	if (typeof str !== 'string') {
		return str;
	}
	try {
		result = JSON.parse(str);
		return result;
	} catch (error) {
		logger.error('util', 'parse json error: ' + str, error);
		return false;
	}
};
